// import { palette, theme as colorTheme } from "../../../Convoze.theme";





// export const graphData = [

//   {
//     option: {
//       title: {
//         text: "Call Direction",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "item" },
//       legend: { bottom: 0 },
//       color: [colorTheme('palette', 'callInbound').value, colorTheme('palette', 'callOutbound').value],
//       series: [
//         {
//           type: "pie",
//           radius: ["40%", "70%"],
//           center: ["50%", "70%"],
//           startAngle: 180,
//           endAngle: 0,
//           data: [
//             { value: 7234, name: "Inbound" },
//             { value: 5613, name: "Outbound" },
//           ],
//         },
//       ],
//     },
//   },


//   {
//     option: {
//       title: { text: 'Sentiment Composition', left: 'left', textStyle: { fontSize: 14 } },
//       tooltip: { trigger: 'item' },
//       legend: { bottom: 0 },
//       color: [colorTheme('palette', 'helpful').value, colorTheme('palette', 'neutral').value, colorTheme('palette', 'negative').value],
//       series: [{ type: 'pie', radius: ['40%', '70%'], data: [{ value: 73.8, name: 'Positive' }, { value: 20.1, name: 'Neutral' }, { value: 6.1, name: 'Negative' }] }],
//     },
//   },


//   {
//     option: {
//       title: {
//         text: "Customer Word Frequency",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "axis" },
//       grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
//       xAxis: {
//         type: "category",
//         data: ["helpful", "slow", "professional", "confused", "satisfied"],
//       },
//       yAxis: { type: "value" },
//       series: [
//         { type: "bar", data: [89, 67, 78, 45, 92], itemStyle: { color: colorTheme('palette', 'primary').value } },
//       ],
//     },
//   },

//   {
//     option: {
//       title: {
//         text: "Campaign Analytics",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "axis" },
//       grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
//       xAxis: {
//         type: "category",
//         data: ["helpful", "slow", "professional", "confused", "satisfied"],
//       },
//       yAxis: { type: "value" },
//       series: [
//         { type: "bar", data: [89, 67, 78, 45, 92], itemStyle: { color: colorTheme('palette', 'primary').value } },
//       ],
//     },
//   },


//   {
//     option: {
//       title: {
//         text: "Average Handling Time by Agent",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "axis" },
//       grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
//       xAxis: {
//         type: "category",
//         data: ["helpful", "slow", "professional", "confused", "satisfied"],
//       },
//       yAxis: { type: "value" },
//       series: [
//         { type: "bar", data: [89, 67, 78, 45, 92], itemStyle: { color: colorTheme('palette', 'primary').value } },
//       ],
//     },
//   },



//   {
//     option: {
//       title: { text: 'Total Call Volume', left: 'left', textStyle: { fontSize: 14 } },
//       tooltip: { trigger: 'axis' },
//       xAxis: { type: 'category', data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
//       yAxis: { type: 'value' },
//       series: [{
//         type: 'line', data: [10500, 12300, 11800, 13400, 14000, 13700], smooth: true,
//         lineStyle: { color: colorTheme('palette', 'totalCallVolume1').value }, itemStyle: { color: colorTheme('palette', 'totalCallVolume2').value }
//       }],
//     },
//   },


//   {
//     option: {
//       title: {
//         text: "Agent Call Volume",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "axis" },
//       grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
//       xAxis: { type: "value" },
//       yAxis: {
//         type: "category",
//         data: ["Chris P.", "Alex K.", "Maria L.", "John D.", "Sarah M."],
//       },
//       series: [
//         {
//           type: "bar",
//           data: [180, 165, 142, 138, 125],
//           itemStyle: { color: colorTheme('palette', 'agentCallVolume').value },
//         },
//       ],
//     },
//   },



//   {
//     option: {
//       title: { text: 'Call Drop Trend', left: 'left', textStyle: { fontSize: 14 } },
//       tooltip: { trigger: 'axis' },
//       xAxis: { type: 'category', data: ['Alice', 'Bob', 'Charlie', 'Diana', 'Eve', 'Frank', 'Grace', 'Henry'] },
//       yAxis: { type: 'value' },
//       series: [{ type: 'line', data: [0.25, 0.5, 0.75, 0.6, 0.4, 0.3, 0.2, 0.1], smooth: true, lineStyle: { color: colorTheme('palette', 'negative').value }, itemStyle: { color: colorTheme('palette', 'negative').value } }]
//     }
//   },


//   {
//     option: {
//       title: { text: 'Resolution Time Distribution', left: 'left', textStyle: { fontSize: 14 } },
//       tooltip: { trigger: 'axis' },
//       grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
//       xAxis: { type: 'category', data: ['<2h', '2-4h', '4-8h', '8-24h', '>24h'] },
//       yAxis: { type: 'value' },
//       series: [{ type: 'bar', data: [6000, 4500, 3000, 1500, 500], itemStyle: { color: colorTheme('palette', 'neutral').value } }]
//     }
//   },




//   {
//     option: {
//       title: {
//         text: "Disposition Analytics",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "item" },
//       legend: { bottom: 0 },
//       color: [colorTheme('palette', 'primary').value, colorTheme('palette', 'neutral').value, colorTheme('palette', 'negative').value, colorTheme('palette', 'pop').value, colorTheme('palette', 'secondary').value],
//       series: [
//         {
//           type: "pie",
//           radius: ["40%", "70%"],
//           data: [
//             { value: 8934, name: "Resolved" },
//             { value: 2156, name: "Follow-up" },
//             { value: 897, name: "Escalated" },
//             { value: 567, name: "Transferred" },
//             { value: 293, name: "Abandoned" },
//           ],
//         },
//       ],
//     },
//   },



//   {
//     option: {
//       title: {
//         text: "Emotion Breakdown",
//         left: "left",
//         textStyle: { fontSize: 14 },
//       },
//       tooltip: { trigger: "item" },
//       legend: { bottom: 0 },
//       color: [colorTheme('palette', 'positive').value, colorTheme('palette', 'secondary').value, colorTheme('palette', 'neutral').value, colorTheme('palette', 'confused').value, colorTheme('palette', 'primary').value, colorTheme('palette', 'sky').value],
//       series: [
//         {
//           type: "pie",
//           radius: ["40%", "70%"],
//           data: [
//             { value: 35.5, name: "Satisfied" },
//             { value: 22.5, name: "Happy" },
//             { value: 21.8, name: "Neutral" },
//             { value: 9.6, name: "Frustrated" },
//             { value: 6.1, name: "Confused" },
//             { value: 4.4, name: "Angry" },
//           ],
//         },
//       ],
//     },
//   },


// ];




import { theme as colorTheme, palette } from "../../../Convoze.theme";



const positive = '#4CAF50';   
const negative = '#FF5252';   
const neutral  = '#FFC881';   
const primary  = '#c6a7ffff';   
const agent    = '#94ebffff';   

const secondary = colorTheme('palette','secondary').value;
const positiveBg = colorTheme('palette', 'positiveBg').value;
const negativeBg = colorTheme('palette', 'negativeBg').value;
const neutralBg = colorTheme('palette', 'neutralBg').value;
const pop = primary;
const sky = agent;
const agentvol = colorTheme('palette','agentCallVolume').value;
const totalCallVol1 = colorTheme('palette','totalCallVolume1').value;
const totalCallVol2 = colorTheme('palette','totalCallVolume1').value;
const outbound =  colorTheme('palette','callOutbound').value;
const inbound =  colorTheme('palette','callInbound').value;



const PAL = {
  callDir    : [
                outbound,
                inbound
              ],
  sentiment  : [positive, neutral, negative],
  primary    : primary,
  neutral    : neutral,
  neutralBg    : neutralBg,
  positive   : positive,
  secondary  : secondary,
  pop        : pop,
  sky        : sky,
  confused   : negative,
  agentVol   : agentvol,
  totalVol1  : totalCallVol1,
  totalVol2  : totalCallVol2,
  negative   : negative,

};



/* ---------- dynamic builders ---------- */
const buildCallDirection = (d) => {
  const raw = d?.callDirection || {};
  const data = Object.entries(raw).map(([n, v]) => ({ name: n, value: v }));
  return {
    title: { text: 'Call Direction', left: 'left', textStyle: { fontSize: 14 } },
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    color: PAL.callDir,
    series: [{ type: 'pie', radius: ['40%', '70%'], center: ['50%', '70%'], startAngle: 180, endAngle: 0, data }],
  };
};

const buildSentiment = (d) => {
  const sc = d?.sentimentData?.sentimentCounts || {};
  const data = [
    { name: 'Positive', value: sc.Positive || 0 },
    { name: 'Neutral',  value: sc.Neutral  || 0 },
    { name: 'Negative', value: sc.Negative || 0 },
  ];
  return {
    title: { text: 'Sentiment Composition', left: 'left', textStyle: { fontSize: 14 } },
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    color: PAL.sentiment,
    series: [{ type: 'pie', radius: ['40%', '70%'], data }],
  };
};

const buildWordFreq = (d) => {
  const list = d?.wordCloudData || [];
  return {
    title: { text: 'Customer Word Frequency', left: 'left', textStyle: { fontSize: 14 } },
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: list.map(i => i.name), axisLabel: { rotate: 30, fontSize: 10 } },
    yAxis: { type: 'value' },
    series: [{ type: 'bar', data: list.map(i => i.value), itemStyle: { color: PAL.primary } }],
  };
};

const buildCampaign = (d) => {
  const names  = d?.campaigns?.campaignNames  || [];
  const counts = d?.campaigns?.campaignCounts || [];
  return {
    title: { text: 'Campaign Analytics', left: 'left', textStyle: { fontSize: 14 } },
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: names, axisLabel: { rotate: 30, fontSize: 10 } },
    yAxis: { type: 'value' },
    series: [{ type: 'bar', data: counts, itemStyle: { color: PAL.primary } }],
  };
};

const buildAHT = (d) => {
  const names = d?.agentAverageHandlingTime?.agentFullName || [];
  const times = d?.agentAverageHandlingTime?.averageHandlingTime || [];
  return {
    title: { text: 'Average Handling Time by Agent', left: 'left', textStyle: { fontSize: 14 } },
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: names, axisLabel: { rotate: 30, fontSize: 10 } },
    yAxis: { type: 'value' },
    series: [{ type: 'bar', data: times, itemStyle: { color: PAL.primary } }],
  };
};



const TotalCallVolume = {
  title: { text: 'Total Call Volume', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'axis' },
  xAxis: { type: 'category', data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'] },
  yAxis: { type: 'value' },
  series: [{ type: 'line', smooth: true, data: [10500, 12300, 11800, 13400, 14000, 13700], lineStyle: { color: PAL.totalVol1 }, itemStyle: { color: PAL.totalVol2 } }],
};

const AgentAnalytics = {
  title: { text: 'Agent Call Volume', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'axis' },
  grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
  xAxis: { type: 'value' },
  yAxis: { type: 'category', data: ['Chris P.', 'Alex K.', 'Maria L.', 'John D.', 'Sarah M.'] },
  series: [{ type: 'bar', data: [180, 165, 142, 138, 125], itemStyle: { color: PAL.agentVol } }],
};

const CallDropTrend = {
  title: { text: 'Call Drop Trend', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'axis' },
  xAxis: { type: 'category', data: ['Alice', 'Bob', 'Charlie', 'Diana', 'Eve', 'Frank', 'Grace', 'Henry'] },
  yAxis: { type: 'value' },
  series: [{ type: 'line', data: [0.25, 0.5, 0.75, 0.6, 0.4, 0.3, 0.2, 0.1], smooth: true, lineStyle: { color: PAL.negative }, itemStyle: { color: PAL.negative } }],
};


const BuildCallDropTrend = (d) => {
  const {
    agentNames = [],
    hangupByCounts = [],  
    totalCalls = []       
  } = d.callHangup || {};


  const dropRatio = totalCalls.map((total, idx) => {
    if (!total) return 0;               
    return +(hangupByCounts[idx] / total).toFixed(2); 
  });


  return {
    title: {
      text: 'Call Drop Trend',
      left: 'left',
      textStyle: { fontSize: 14 }
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const { axisValue, value } = params[0];
        return `${axisValue}<br/>Drop ratio: <b>${(value * 100).toFixed(1)} %</b>`;
      }
    },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      data: agentNames,
      axisLabel: { rotate: 30, fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: (v) => `${(v * 100).toFixed(0)} %` 
      }
    },
    series: [{
      type: 'line',
      smooth: true,
      data: dropRatio,
      lineStyle: { color: PAL.negative, width: 2 },
      itemStyle: { color: PAL.negative },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0, y: 0, x2: 0, y2: 1,
          colorStops: [
            { offset: 0, color: 'rgba(239, 83, 80, 0.35)' },
            { offset: 1, color: 'rgba(239, 83, 80, 0.05)' }
          ]
        }
      }
    }]
  };
};




const ResolutionDistribution = {
  title: { text: 'Resolution Time Distribution', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'axis' },
  grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
  xAxis: { type: 'category', data: ['<2h', '2-4h', '4-8h', '8-24h', '>24h'] },
  yAxis: { type: 'value' },
  series: [{ type: 'bar', data: [6000, 4500, 3000, 1500, 500], itemStyle: { color: PAL.neutral } }],
};

const DispositionAnalytics = {
  title: { text: 'Disposition Analytics', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'item' },
  legend: { bottom: 0 },
  color: [PAL.primary, PAL.neutral, PAL.negative, PAL.pop, PAL.secondary],
  series: [{ type: 'pie', radius: ['40%', '70%'], data: [{ value: 8934, name: 'Resolved' }, { value: 2156, name: 'Follow-up' }, { value: 897, name: 'Escalated' }, { value: 567, name: 'Transferred' }, { value: 293, name: 'Abandoned' }] }],
};


const Emotionbreakdown = {
  title: { text: 'Emotion Breakdown', left: 'left', textStyle: { fontSize: 14 } },
  tooltip: { trigger: 'item' },
  legend: { bottom: 0 },
  color: [PAL.positive, PAL.positive, PAL.neutral, PAL.negative, PAL.neutralBg, PAL.negative],
  series: [{ type: 'pie', radius: ['40%', '70%'], data: [{ value: 35.5, name: 'Satisfied' }, { value: 22.5, name: 'Happy' }, { value: 21.8, name: 'Neutral' }, { value: 9.6, name: 'Frustrated' }, { value: 6.1, name: 'Confused' }, { value: 4.4, name: 'Angry' }] }],
};





const TREND_COLORS = ['#2563EB', '#7C3AED', '#059669', '#D97706', '#DC2626'];

const buildTrendGraph = (trendData = {}, key, title) => {
  const dateLabels = trendData?.dateLabels || [];
  const rows = Array.isArray(trendData?.[key]) ? [...trendData[key]] : [];
  const seriesRows = rows.sort((left, right) => (right?.totalCalls || 0) - (left?.totalCalls || 0)).slice(0, 5);

  // Only show dates where at least one row has actual call data
  const activeDates = new Set(
    rows.flatMap(item => (item?.trend || []).filter(d => (d.totalCalls || 0) > 0).map(d => d.date))
  );
  const filteredDateLabels = dateLabels.filter(d => activeDates.has(d));

  return {
    title: {
      text: title,
      left: 'left',
      textStyle: { fontSize: 14, fontWeight: 700, color: '#464646' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      formatter: (params = []) => {
        const axisLabel = params?.[0]?.axisValueLabel || params?.[0]?.axisValue || 'N/A';
        const lines = params.map(item => {
          const score = Number(item?.data?.value || 0).toFixed(2);
          const calls = item?.data?.totalCalls || 0;
          return `${item.marker} ${item.seriesName}: <b>${score}</b> (${calls} calls)`;
        });
        return [axisLabel, ...lines].join('<br/>');
      },
    },
    legend: { top: 26, type: 'scroll' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: filteredDateLabels, boundaryGap: false, axisLabel: { rotate: 25, fontSize: 10 } },
    yAxis: { type: 'value', min: 0, max: 100, name: 'Call Score', nameLocation: 'middle', nameGap: 40 },
    series: seriesRows.map((item, index) => {
      const color = TREND_COLORS[index % TREND_COLORS.length];
      const label = item?.agentName || item?.language || 'Unknown';
      const trendPoints = filteredDateLabels.map(date => {
        const point = (item?.trend || []).find(entry => entry?.date === date) || {};
        return {
          value: Number(point?.averageCallScore || 0),
          totalCalls: Number(point?.totalCalls || 0),
          date,
        };
      });

      return {
        name: label,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: trendPoints,
        lineStyle: { width: 2, color },
        itemStyle: { color },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: `${color}55` },
              { offset: 1, color: `${color}10` },
            ],
          },
        },
        emphasis: { focus: 'series' },
      };
    }),
  };
};

export const buildAgentTrendGraph = (trendData = {}) =>
  buildTrendGraph(trendData, 'agentTrend', 'Agent Wise Call Score Trend');

export const buildLanguageTrendGraph = (trendData = {}) =>
  buildTrendGraph(trendData, 'languageTrend', 'Language Wise Call Score Trend');

export const buildSingleTrendGraph = (trendData = {}, key, title, selectedValue, colors = {}) => {
  const dateLabels = trendData?.dateLabels || [];
  const rows = Array.isArray(trendData?.[key]) ? trendData[key] : [];
  // Agent rows are matched by agentId now (a stable UserDetail id), not by
  // agentName - language/parameter rows have no id, so they keep matching by name.
  const selectedItem =
    rows.find(item => String(item?.agentId ?? item?.language ?? item?.parameter ?? item?.subParameter ?? '') === String(selectedValue)) ||
    rows[0];

  const selectedName = selectedItem?.agentName || selectedItem?.language || selectedItem?.parameter || selectedItem?.subParameter || 'Unknown';
  const trend = Array.isArray(selectedItem?.trend) ? selectedItem.trend : [];

  // Only show dates where the selected agent/language has actual call data
  const activeDates = new Set(
    trend.filter(d => (d.totalCalls || 0) > 0).map(d => d.date)
  );
  const filteredDateLabels = dateLabels.filter(d => activeDates.has(d));

  const seriesData = filteredDateLabels.map(date => {
    const point = trend.find(entry => entry?.date === date) || {};
    return {
      value: Number(point?.averageCallScore || 0),
      totalCalls: Number(point?.totalCalls || 0),
      date,
    };
  });

  const lineColor = colors.lineColor || '#2563EB';
  const areaColorTop = colors.areaColorTop || 'rgba(37, 99, 235, 0.28)';
  const areaColorBottom = colors.areaColorBottom || 'rgba(37, 99, 235, 0.05)';

  return {
    title: {
      text: title,
      left: 'left',
      textStyle: { fontSize: 14, fontWeight: 700, color: '#464646' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      formatter: (params = []) => {
        const axisLabel = params?.[0]?.axisValueLabel || params?.[0]?.axisValue || 'N/A';
        const item = params?.[0]?.data || {};
        return [
          axisLabel,
          `${params?.[0]?.marker || ''} ${selectedName}: <b>${Number(item?.value || 0).toFixed(2)}</b> (${item?.totalCalls || 0} calls)`,
        ].join('<br/>');
      },
    },
    legend: { show: false },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: filteredDateLabels, boundaryGap: false, axisLabel: { rotate: 25, fontSize: 10 } },
    yAxis: { type: 'value', min: 0, max: 100, name: 'Call Score', nameLocation: 'middle', nameGap: 40 },
    series: [{
      name: selectedName,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 6,
      data: seriesData,
      lineStyle: { width: 2, color: lineColor },
      itemStyle: { color: lineColor },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: areaColorTop },
            { offset: 1, color: areaColorBottom },
          ],
        },
      },
    }],
  };
};

export const graphData = (cardDetails = {}) => [
  buildCallDirection(cardDetails),   
  buildSentiment(cardDetails),      
  buildWordFreq(cardDetails),        
  buildCampaign(cardDetails),      
  buildAHT(cardDetails),         
  AgentAnalytics,                   
  DispositionAnalytics,            
  BuildCallDropTrend(cardDetails),                    
  TotalCallVolume,                   
  ResolutionDistribution,         
  Emotionbreakdown,     



];
